/* eslint-disable */

import * as ApolloReactComponents from '@apollo/client/react/components';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type SiteFragment = {
    __typename: 'Site';
    domain: string;
    locale: string;
    phoneSupport: string;
    phoneOfficeHours: Types.Maybe<string>;
    currency: string;
    acceptedLocales: Array<{ __typename: 'Locale'; tag: string; title: string }>;
};

export type CreateQueryVariables = Types.Exact<{ [key: string]: never }>;

export type CreateQuery = {
    __typename: 'Query';
    site: { __typename: 'Site' } & SiteFragment;
    me: {
        __typename: 'Viewer';
        user: Types.Maybe<{
            __typename: 'User';
            id: string;
            isAdmin: boolean;
            isDesigner: boolean;
        }>;
    };
};

export const SiteFragmentDoc: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Site' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Site' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'acceptedLocales' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'phoneSupport' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'phoneOfficeHours' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                ],
            },
        },
    ],
};
export const CreateDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'Create' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'site' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Site' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'me' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'user' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isAdmin' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isDesigner' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Site' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Site' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'acceptedLocales' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'domain' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'phoneSupport' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'phoneOfficeHours' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                ],
            },
        },
    ],
};
export type CreateComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<CreateQuery, CreateQueryVariables>,
    'query'
>;

export const CreateComponent = (props: CreateComponentProps) => (
    <ApolloReactComponents.Query<CreateQuery, CreateQueryVariables>
        query={CreateDocument}
        {...props}
    />
);

/**
 * __useCreateQuery__
 *
 * To run a query within a React component, call `useCreateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreateQuery(
    baseOptions?: Apollo.QueryHookOptions<CreateQuery, CreateQueryVariables>
) {
    return Apollo.useQuery<CreateQuery, CreateQueryVariables>(CreateDocument, baseOptions);
}
export function useCreateLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<CreateQuery, CreateQueryVariables>
) {
    return Apollo.useLazyQuery<CreateQuery, CreateQueryVariables>(CreateDocument, baseOptions);
}
export type CreateQueryHookResult = ReturnType<typeof useCreateQuery>;
export type CreateLazyQueryHookResult = ReturnType<typeof useCreateLazyQuery>;
export type CreateQueryResult = Apollo.QueryResult<CreateQuery, CreateQueryVariables>;
